import { HStack, VStack, Text, Button, Flex } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { SectionCard } from "../../../shared/ui";
import { Building2, Calendar, FileText, Check, ArrowRight } from "../../../shared/icons";

// Cada passo mapeia uma chave da resposta de GET /api/v1/onboarding/status (calculada a
// partir de dados que já existem em outros bounded contexts — ver OnboardingUseCase.Status
// no backend) para o texto/ícone/rota exibidos aqui.
const STEPS = [
  {
    key: "workplace_registered",
    title: "Cadastrar local de trabalho",
    icon: Building2,
    to: "/vinculos",
  },
  {
    key: "first_shift_registered",
    title: "Registrar primeiro plantão",
    subtitle: "No calendário, com data e horas trabalhadas",
    icon: Calendar,
    to: "/calendario",
  },
  {
    key: "tax_regime_configured",
    title: "Configurar regime tributário",
    subtitle: "Opcional",
    icon: FileText,
    to: "/perfil",
  },
];

function StepIcon({ done, icon: Icon }) {
  return (
    <Flex
      align="center"
      justify="center"
      boxSize="40px"
      borderRadius="full"
      bg={done ? "success.500" : "app-muted"}
      color={done ? "white" : "app-muted-fg"}
      flexShrink={0}
    >
      {done ? <Check size={20} /> : <Icon size={20} />}
    </Flex>
  );
}

export default function OnboardingChecklist({ status }) {
  const navigate = useNavigate();

  return (
    <SectionCard title="Primeiros passos">
      <Text fontSize="sm" color="app-muted-fg" mb={4}>
        Cadastre um local de trabalho e um plantão para ver quanto e quando você vai receber.
      </Text>

      <VStack align="stretch" spacing={3}>
        {STEPS.map((step) => {
          const done = Boolean(status?.[step.key]);
          return (
            <HStack
              key={step.key}
              justify="space-between"
              border="1px solid"
              borderColor="app-border"
              borderRadius="lg"
              p={3}
              spacing={3}
            >
              <HStack spacing={3} align="center">
                <StepIcon done={done} icon={step.icon} />
                <VStack align="flex-start" spacing={0}>
                  <Text fontWeight="medium" textDecoration={done ? "line-through" : "none"} color={done ? "app-muted-fg" : undefined}>
                    {step.title}
                  </Text>
                  {!done && step.subtitle ? (
                    <Text fontSize="xs" color="app-muted-fg">
                      {step.subtitle}
                    </Text>
                  ) : null}
                </VStack>
              </HStack>

              {!done ? (
                <Button size="sm" variant="ghost" rightIcon={<ArrowRight size={14} />} onClick={() => navigate(step.to)} flexShrink={0}>
                  Ir
                </Button>
              ) : null}
            </HStack>
          );
        })}
      </VStack>
    </SectionCard>
  );
}
